import { useState, useEffect } from 'react'
import { Button, Card, Col, Modal, Row } from 'react-bootstrap'
import React from 'react'
import { Schema, Form, AutoComplete } from 'rsuite';
import YesNoRadioOption from '../../../Shared/RadioButton/YesNoRadioOption';
import { getIndividualCredentials } from '../../../../services/Shared/codeTable.service'
import RedStar from '../../../Shared/GenericComponents/RedStar';
import supervisingProfessionalService from '../../../../services/supervisingProfessional.service';
import Swal from 'sweetalert2';

function AddNewSupervisingProfessionalModal(props) {
    const [individualCreds, setIndividualCreds] = useState();
    const updateIndividualCreds = (value) => {
        getIndividualCredentials(value, props.prefix).then(setIndividualCreds);
    }
    const [supervisingProfessionalModel, setSupervisingProfessionalModel] = useState({
        individualCredential: "",
        ownerOfFirm: ""
    })

    const { StringType, BooleanType } = Schema.Types;
    const model = Schema.Model({
        individualCredential: StringType().isRequired('This field is required.').pattern(/^.*\.[0-9]{7}.*$/, "Please select a license number."),
        ownerOfFirm: BooleanType().isRequired('This field is required.'),
    })
    const formSubmit = (val, event) => {
        if (val) {
            var licenseNum = supervisingProfessionalModel.individualCredential ? supervisingProfessionalModel.individualCredential.split("(")[1].split(")")[0] : null;
            supervisingProfessionalService.postFirmSupervisingProfessional(licenseNum, supervisingProfessionalModel.ownerOfFirm, props.parentId, props.parentTypeId).then((response) => {
                if (response.data.supervisingProfessionalId) {
                    props.updateGrid();
                    props.onHide();
                    setSupervisingProfessionalModel({
                        individualCredential: "",
                        ownerOfFirm: ""
                    });
                    Swal.fire({
                        title: 'Saved',
                        html: `An email notification has been sent to ${response.data.professionalEmailAddress} to complete a Supervising Professional (SP) Attestation Form in order to accept the role of SP. Status of SP will remain "Pending" until the form is submitted. Once the form has been submitted, status will change to "Verified", and the firm will be able to complete the application, renewal, or reinstatement.`,
                        icon: 'success',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'I have read and understood the message',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showCancelButton: false
                    })
                }
            }).catch((error) => { if (error?.response?.data) { Swal.fire("Error!", error?.response?.data, 'error') } });
        }
    }

    return (
        <Modal
            {...props}
            animation={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Supervising Professionals
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form
                    model={model}
                    id="supervisingProfessionalForm"
                    formValue={supervisingProfessionalModel}
                    onChange={setSupervisingProfessionalModel}
                    onSubmit={formSubmit}
                    fluid>
                    <Form.Group>

                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        License #&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control
                                    accepter={AutoComplete}
                                    block
                                    data={individualCreds}
                                    name="individualCredential"
                                    placeholder="License # | First Last Name"
                                    onChange={updateIndividualCreds} />
                            </Col>
                            <Form.HelpText className="d-none">License # Selection</Form.HelpText>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Owner of this firm?&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <YesNoRadioOption radioName="ownerOfFirm" />
                            </Col>
                        </Row>
                    </Form.Group>
                </Form>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { props.onHide(); }}>Close</Button>
                <Button type="submit" form="supervisingProfessionalForm" >Add New</Button>
            </Modal.Footer>
        </Modal >
    );
}

export default AddNewSupervisingProfessionalModal;